import lodash from 'lodash';
import React, { Component, Fragment } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Link } from 'react-router-dom';
import {
    FormControlLabel, Checkbox, FormGroup, Paper, IconButton, Icon,
} from '@material-ui/core';
import {
    Input, Select, Spin, DatePicker, InputNumber,
} from 'antd';
import moment from 'moment';
import { getLeadsDivisionsRequest } from '../redux/actions/get_leads_divisions.actions';
import { getLeadsAffiliateRequest } from '../redux/actions/get_leads_affiliate.actions';
import { searchByBrandRequest } from '../../../PlatformManagement/BikeManagement/redux/actions/search_by_brand.actions';
import {
    searchBikeModelRequest,
} from '../../../PlatformManagement/BikeManagement/redux/actions/search_bike_model.actions';
import { searchByRegRequest } from '../../../PlatformManagement/BikeManagement/redux/actions/search_by_reg.actions';
import { debounce } from '../../../../shared/helpers';
import {
    getLeadsRequest,
    setLeadManageKey,
    resetTableFilters,
    toggleShowLeadsAdditionalFilters,
} from '../redux/actions/get_leads.actions';
import { getUsersList } from '../redux/actions/get_users_list.actions';
import { leadManageGetLeadsStatusRequest } from '../redux/actions/lead_manage_lead_status.actions';
import SearchBar from '../../../../components/table/SearchBar';

const { Option } = Select;
const { RangePicker } = DatePicker;

let page;

class LeadsFilters extends Component {
    constructor(props) {
        super(props);
        this.toggleSearch = this.toggleSearch.bind(this);
    }

    componentDidMount() {
        // eslint-disable-next-line no-nested-ternary
        const currentPage = this.props.isLeadManageDeliveryRequested ? 'deliveryRequested' : this.props.isLeadManageLeadomatic ? 'leadomatic' : '';

        if (page !== currentPage) {
            if (page !== undefined) {
                this.props.resetTableFilters();
            }
            page = currentPage;
        }

        if (!this.props.isLeadManageDeliveryRequested) {
            if (lodash.isEmpty(this.props.leadsDivisions)) {
                this.props.getLeadsDivisionsRequest();
            }

            if (lodash.isEmpty(this.props.leadsStatus)) {
                this.props.leadManageGetLeadsStatusRequest();
            }

            if (lodash.isEmpty(this.props.leadsAffiliate)) {
                this.props.getLeadsAffiliateRequest();
            }
        }
    }

    setFilterRedux = (key, value) => {
        if (value === '' || value === undefined) {
            this.props.setLeadManageKey(`filters.${key}`, undefined);
        } else {
            this.props.setLeadManageKey(`filters.${key}`, value);
        }
    };

    getLeadsRequestHandler = () => {
        this.props.getLeadsRequest();
        this.forceUpdate();
    };

    debouncedGetLeadRequest = debounce(this.getLeadsRequestHandler, 500);

    onChange = (keyFilter) => (value) => {
        if (keyFilter === 'ref_lead_source') {
            this.props.setLeadManageKey('filters', { ref_lead_source: value, hide_leadomatic_leads: false });
        } else {
            this.setFilterRedux(keyFilter, value);

            if (value === 'Black') {
                this.props.setLeadManageKey('active_lead_manage_tab', '6');

                this.setFilterRedux('is_trade', true);
            }
        }
        this.getLeadsRequestHandler();
    };

    toggleSearch(e) {
        e.preventDefault();
        this.props.toggleShowLeadsAdditionalFilters();
    }

    hideDuplicates = (keyFilter) => (e) => {
        this.setFilterRedux(keyFilter, e.target.checked);
        this.getLeadsRequestHandler();
    };

    hideLeadomaticLeads = (keyFilter) => (e) => {
        this.setFilterRedux(keyFilter, e.target.checked);
        this.getLeadsRequestHandler();
    };

    statusOnChange = (keyFilter) => (statusValue) => {
        this.setFilterRedux(keyFilter, statusValue);
        this.getLeadsRequestHandler();
    };

    showManagerSpecials = (keyFilter) => (e) => {
        this.setFilterRedux(keyFilter, e.target.checked);
        this.getLeadsRequestHandler();
    };

    searchByReg = (value) => {
        this.setFilterRedux('vrm', value);
        if (value.length === 0 || value.length >= 3) {
            this.debouncedGetLeadRequest(value);
        }
    };

    searchByPostcode = (e) => {
        this.setFilterRedux('post_code', e.target.value);
        if (e.target.value.length === 0 || e.target.value.length >= 3) {
            this.debouncedGetLeadRequest(e.target.value);
        }
    };

    searchByCustomer = (e) => {
        this.setFilterRedux('customer', e.target.value);
        if (e.target.value.length === 0 || e.target.value.length >= 3) {
            this.debouncedGetLeadRequest(e.target.value);
        }
    };

    searchByBrand = (value) => {
        this.props.searchByBrandRequest(value);
        this.props.searchBikeModelRequest('', value);
    };

    searchByModel = (value) => {
        this.props.searchBikeModelRequest(value, this.props.filters.ref_bike_brand);
    };

    brandChange = (value, filter) => {
        this.setFilterRedux(filter, value);
        this.getLeadsRequestHandler();
    };

    modelChange = (value, filter) => {
        this.setFilterRedux(filter, value);
        this.getLeadsRequestHandler();
    };


    dateChangeHandler = (e) => {
        if (e && e.length !== 0) {
            this.props.setLeadManageKey('filters', { dateFrom: e[0].toISOString(), dateTo: e[1].toISOString() });
        } else {
            this.props.setLeadManageKey('filters', { dateFrom: undefined, dateTo: undefined });
        }
        this.getLeadsRequestHandler();
    };

    searchUsers = (value) => {
        this.props.getUsersList(value);
        this.forceUpdate();
    };

    debouncedSearchUsers = debounce(this.searchUsers, 500);

    handleSearchUsers = (value) => {
        this.debouncedSearchUsers(value);
    };

    onRangeChange = (fromKey, toKey) => (side, value) => {
        const key = side === 'from' ? fromKey : toKey;
        this.setFilterRedux(key, value ?? undefined);
        this.debouncedGetLeadRequest();
    };

    blemishRatingChange = (value) => {
        this.setFilterRedux('rag_rating', value);
        this.getLeadsRequestHandler();
    };

    handleResetTableFilters = () => {
        this.props.resetTableFilters();
        this.getLeadsRequestHandler();
    }

    render() {
        const { isLeadManageDeliveryRequested } = this.props;

        return (!isLeadManageDeliveryRequested && (
            <Fragment>
                <FormGroup row>
                    <SearchBar
                        onClickRefresh={this.getLeadsRequestHandler}
                        onSearch={this.searchByReg}
                        searchPlaceholder="Search by VRM"
                        searchValue={this.props.filters.vrm}
                        menu={{
                            items: [
                                {
                                    content: 'More Search Criteria',
                                    icon: 'read_more',
                                    onClick: this.toggleSearch,
                                },
                                {
                                    content: <Link style={{ color: 'inherit' }} to="/Leads/Lead_create">Add Lead</Link>,
                                    icon: 'add',
                                },
                                {
                                    content: 'Reset Table Filters',
                                    icon: 'restart_alt',
                                    onClick: this.handleResetTableFilters,
                                },
                            ],
                        }}
                    />

                    <div style={{ marginLeft: '10px' }}>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    checked={this.props.filters.hideDuplicate}
                                    onChange={this.hideDuplicates('hideDuplicate')}
                                    name="checkedA"
                                    color="primary"
                                />
                            )}
                            label="Hide Duplicates"
                        />

                        <FormControlLabel
                            control={(
                                <Checkbox
                                    checked={this.props.filters.is_manager_special}
                                    onChange={this.showManagerSpecials('is_manager_special')}
                                    name="checkedB"
                                    color="primary"
                                />
                            )}
                            label="Show Manager Specials"
                        />
                    </div>

                    <div style={{ marginTop: '5px' }}>
                        <Select
                            allowClear
                            showSearch
                            onChange={this.onChange('lead_pot')}
                            placeholder="Lead Priority"
                            style={{ width: 180, marginRight: 2 }}
                            value={this.props.filters.lead_pot}
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        >
                            <Option value="All">All Bikes</Option>
                            <Option value="Unknown">Unknown Matches</Option>
                            <Option value="Green">Green</Option>
                            <Option value="Amber">Amber</Option>
                            <Option value="Red">Red</Option>
                            <Option value="Black">Black</Option>
                        </Select>
                        <RangePicker
                            style={{ width: 270, margin: '0 2px 0 0' }}
                            onChange={this.dateChangeHandler}
                            value={this.props.filters.dateFrom && [moment(this.props.filters.dateFrom), moment(this.props.filters.dateTo)]}
                        />
                        <Select
                            allowClear
                            showSearch
                            onChange={this.onChange('ref_lead_status')}
                            placeholder="Status"
                            style={{ width: 280, marginRight: 2 }}
                            value={this.props.filters.ref_lead_status}
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {
                                this.props.leadsStatus && this.props.leadsStatus.map((status) => (
                                    <Option value={status._id} key={status._id}>{status.name}</Option>
                                ))
                            }
                        </Select>

                        {
                            !this.props.isLeadManageLeadomatic && (
                                <Select
                                    allowClear
                                    // style={{ width: 220, margin: '0 2px' }}
                                    onChange={this.onChange('ref_lead_source')}
                                    placeholder="Division"
                                    style={{ width: 250, marginRight: 2 }}
                                    value={this.props.filters.ref_lead_source}
                                >
                                    {this.props.leadsDivisions && this.props.leadsDivisions.filter((item) => {
                                        const excludeSource = [
                                            // Leadomatic
                                            '5be93e5f683059f77dbcef4c',
                                        ];

                                        return !excludeSource.includes(item._id);
                                    }).map((division) => (
                                        <Option value={division._id} key={division._id}>{division.name}</Option>
                                    ))}
                                </Select>
                            )
                        }
                    </div>
                </FormGroup>

                <Paper
                    style={{ display: this.props.isShownAdditionalFilters ? 'inline-flex' : 'none' }}
                    className="searchCriteriaExtra"
                >
                    <Input
                        placeholder="Search by Postcode"
                        style={{ width: 180, marginRight: 2 }}
                        onChange={this.searchByPostcode}
                        maxLength={10}
                        value={this.props.filters.post_code}
                    />
                    <Input
                        placeholder="Search by customer"
                        style={{ width: 200, marginRight: 4 }}
                        onChange={this.searchByCustomer}
                        maxLength={30}
                        value={this.props.filters.customer}
                    />
                    <Select
                        showSearch
                        allowClear
                        placeholder="Search by Make"
                        notFoundContent="Make not Found"
                        filterOption={false}
                        onSearch={this.searchByBrand}
                        onChange={(value) => this.brandChange(value, 'ref_bike_brand')}
                        style={{ width: 150, marginRight: 4 }}
                        value={this.props.filters.ref_bike_brand}
                    >
                        {this.props.filteredBrands && this.props.filteredBrands.map((brand) => (
                            <Select.Option
                                key={brand._id}
                            >
                                {brand.name}
                            </Select.Option>
                        ))}
                    </Select>

                    <Select
                        // ref={element => select = element}
                        showSearch
                        allowClear
                        placeholder="Search by Model"
                        notFoundContent="Model not Found"
                        filterOption={false}
                        disabled={!this.props.filters.ref_bike_brand}
                        onSearch={this.searchByModel}
                        onChange={(value) => this.modelChange(value, 'ref_bike_model')}
                        style={{ width: 200, marginRight: 4 }}
                        value={this.props.filters.ref_bike_model}
                    >
                        {this.props.filteredModels && this.props.filteredModels.map((model) => (
                            <Select.Option
                                key={model._id}
                            >
                                {`${model.name} ${model.model_variation} [cc: ${model.cc}]`}
                            </Select.Option>
                        ))}
                    </Select>

                    <Select
                        allowClear
                        showSearch
                        notFoundContent={this.props.fetching_users
                            ? <Spin size="small" /> : 'Agent not Found'}
                        filterOption={false}
                        placeholder="Agent"
                        style={{ width: 200, marginRight: 4 }}
                        onSearch={this.handleSearchUsers}
                        onChange={this.onChange('ref_assigned_to')}
                        value={this.props.filters.ref_assigned_to}
                        loading={this.props.fetching_users}
                    >
                        {
                            this.props.users
                            && this.props.users.map(
                                (agent) => agent.person
                                    && (
                                        <Option value={agent._id} key={agent._id}>
                                            {`${agent.person.first_name} ${agent.person.last_name}`}
                                        </Option>
                                    ),
                            )
                        }
                    </Select>
                    <Select
                        allowClear
                        style={{ width: 200, margin: '0 2px' }}
                        onChange={this.onChange('ref_lead_affiliate')}
                        placeholder="Affiliate"
                        value={this.props.filters.ref_lead_affiliate}
                    >
                        {this.props.leadsAffiliate && this.props.leadsAffiliate.map((affiliate) => (
                            <Option value={affiliate._id} key={affiliate._id}>{affiliate.name}</Option>
                        ))}
                    </Select>

                    <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between' }}>
                        <span style={{ margin: '0 4px 0 8px', whiteSpace: 'nowrap', lineHeight: '32px' }}>Mileage:</span>
                        <InputNumber
                            placeholder="From"
                            min={0}
                            style={{ width: 90, marginRight: 2 }}
                            value={this.props.filters.mileageFrom}
                            onChange={(val) => this.onRangeChange('mileageFrom', 'mileageTo')('from', val)}
                        />
                        <InputNumber
                            placeholder="To"
                            min={0}
                            style={{ width: 90, marginRight: 8 }}
                            value={this.props.filters.mileageTo}
                            onChange={(val) => this.onRangeChange('mileageFrom', 'mileageTo')('to', val)}
                        />
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between' }}>
                        <span style={{ margin: '0 4px 0 0', whiteSpace: 'nowrap', lineHeight: '32px' }}>Year:</span>
                        <InputNumber
                            placeholder="From"
                            min={1900}
                            max={new Date().getFullYear()}
                            style={{ width: 80, marginRight: 2 }}
                            value={this.props.filters.yearFrom}
                            onChange={(val) => this.onRangeChange('yearFrom', 'yearTo')('from', val)}
                        />
                        <InputNumber
                            placeholder="To"
                            min={1900}
                            max={new Date().getFullYear()}
                            style={{ width: 80, marginRight: 8 }}
                            value={this.props.filters.yearTo}
                            onChange={(val) => this.onRangeChange('yearFrom', 'yearTo')('to', val)}
                        />
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between' }}>
                        <span style={{ margin: '0 4px 0 0', whiteSpace: 'nowrap', lineHeight: '32px' }}>Valuation:</span>
                        <InputNumber
                            placeholder="£ From"
                            min={0}
                            style={{ width: 90, marginRight: 2 }}
                            value={this.props.filters.valuationFrom}
                            onChange={(val) => this.onRangeChange('valuationFrom', 'valuationTo')('from', val)}
                        />
                        <InputNumber
                            placeholder="£ To"
                            min={0}
                            style={{ width: 90, marginRight: 8 }}
                            value={this.props.filters.valuationTo}
                            onChange={(val) => this.onRangeChange('valuationFrom', 'valuationTo')('to', val)}
                        />
                    </div>

                    <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between' }}>
                        <span style={{ margin: '0 4px 0 0', whiteSpace: 'nowrap', lineHeight: '32px' }}>Margin:</span>
                        <InputNumber
                            placeholder="£ From"
                            style={{ width: 90, marginRight: 2 }}
                            value={this.props.filters.marginFrom}
                            onChange={(val) => this.onRangeChange('marginFrom', 'marginTo')('from', val)}
                        />
                        <InputNumber
                            placeholder="£ To"
                            style={{ width: 90, marginRight: 8 }}
                            value={this.props.filters.marginTo}
                            onChange={(val) => this.onRangeChange('marginFrom', 'marginTo')('to', val)}
                        />
                    </div>

                    <Select
                        allowClear
                        style={{ width: 160, marginRight: 4 }}
                        onChange={this.blemishRatingChange}
                        placeholder="Blemish Rating"
                        value={this.props.filters.rag_rating}
                    >
                        <Option value="Green">Blemish: Green</Option>
                        <Option value="Amber">Blemish: Amber</Option>
                    </Select>

                    <IconButton
                        title="close"
                        aria-label="Close"
                        style={{ padding: '5px', marginLeft: '5px' }}
                        onClick={this.toggleSearch}
                    >
                        <Icon fontSize="small" color="inherit">close</Icon>
                    </IconButton>
                </Paper>
            </Fragment>
        ));
    }
}


const mapStateToProps = (state) => ({
    leadsDivisions: state.Leads.Leads_manage.divisions,
    leadsStatus: state.Leads.Leads_manage.leadsStatus,
    isShownAdditionalFilters: state.Leads.Leads_manage.isShownAdditionalFilters,
    filters: state.Leads.Leads_manage.filters,
    loading: state.Leads.Leads_manage.loading,
    pagination: state.Leads.Leads_manage.pagination,
    users: state.Leads.Leads_manage.modal_data.users.data,
    fetching_users: state.Leads.Leads_manage.modal_data.users.fetching_users,
    filteredUsers: state.Leads.Leads_manage.filteredUsers,
    leadsAffiliate: state.Leads.Leads_manage.affiliate,
    filteredBrands: state.PlatformManagement.Bike_management.filteredBrands,
    filteredModels: state.PlatformManagement.Bike_management.filteredModels,
});


export default connect(mapStateToProps, {
    getLeadsRequest,
    toggleShowLeadsAdditionalFilters,
    getLeadsDivisionsRequest,
    leadManageGetLeadsStatusRequest,
    getUsersList,
    getLeadsAffiliateRequest,
    searchByBrandRequest,
    searchBikeModelRequest,
    searchByRegRequest,
    setLeadManageKey,
    resetTableFilters,
})(LeadsFilters);



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/components/LeadsFilters.js